import { Box, Grid, Typography, useMediaQuery, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";

import product1 from '../../assets/image/landing/product1.png';
import product2 from '../../assets/image/landing/product2.png';
import product3 from '../../assets/image/landing/product3.png';
import product4 from '../../assets/image/landing/product4.png';
import product5 from '../../assets/image/landing/product5.png';
import bannerProd from '../../assets/image/landing/prducts-banner.png';

import civilian1 from "../../assets/image/landing/civilian1.png";
import civilian2 from "../../assets/image/landing/civilian2.png";
import civilian3 from "../../assets/image/landing/civilian3.png";
import civilian4 from "../../assets/image/landing/civilian4.png";

const OfferingSectionComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const militaryItems = [
        { title: 'Sonars', image: product1 },
        { title: 'Vessels', image: product2 },
        { title: 'Radars', image: product3 },
        { title: 'Cybersecurity', image: product4 },
        { title: 'Defense Equipment', image: product5 },
    ];

    const civilianItems = [
        { title: 'Ports Security', image: civilian1 },
        { title: 'eNotarization', image: civilian2 },
        { title: 'Blockchain Technology', image: civilian3 },
        { title: 'Digital Trust Platform', image: civilian4 },
    ];

    return (
        <Box
            sx={{
                py: 12,
                px: isSmallScreen ? 2 : 10,
                backgroundColor: '#08244d',
                backgroundImage: `url(${bannerProd})`,
                backgroundSize: 'cover',
                backgroundPosition: 'left center', // Keep 'left center' from Military or 'center' from Civilian? 'left center' anchors the flag.
                backgroundBlendMode: 'multiply',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* MILITARY DEFENSE SECTION */}
            <Box id="military-defense" sx={{ scrollMarginTop: '100px' }}> {/* Add scrollMarginTop for navbar offset */}
                <Grid container sx={{ textAlign: 'center', mb: 8 }}>
                    <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: isSmallScreen ? 40 : 60, color: '#fff' }}>
                            Military Defense
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={4} justifyContent="center" alignItems="center">
                    {militaryItems.map((item, index) => (
                        <Grid item xs={6} sm={4} md={4} key={index}>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >

                                <Box
                                    sx={{
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        padding: 4,
                                        height: 250,
                                        // No Card Style - Just Floating
                                        backgroundColor: 'transparent',
                                        borderRadius: 2,
                                        transition: 'all 0.3s',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            filter: 'drop-shadow(0 0 15px rgba(79, 172, 254, 0.6))'
                                        }
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={item.image}
                                        alt={item.title}
                                        sx={{
                                            width: 100,
                                            height: 100,
                                            objectFit: 'contain',
                                            mb: 2,
                                            filter: 'drop-shadow(0 0 5px rgba(50, 200, 255, 0.5)) brightness(1.2)'
                                        }}
                                    />
                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        sx={{
                                            color: '#fff',
                                            textTransform: 'uppercase',
                                            letterSpacing: 2,
                                            textAlign: 'center',
                                            fontSize: isSmallScreen ? '0.9rem' : '1.1rem'
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </Box>

                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            {/* SPACER / DIVIDER */}
            <Box sx={{ my: 15 }} />

            {/* CIVILIAN DEFENSE SECTION */}
            <Box id="civilian-defense" sx={{ scrollMarginTop: '100px' }}>
                <Grid container sx={{ textAlign: 'center', mb: 8 }}>
                    <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 'bold', fontSize: isSmallScreen ? 40 : 60, mb: 2, color: '#fff' }}>
                            Civilian Defense
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.8, maxWidth: 800, mx: 'auto', color: '#fff' }}>
                            Ensuring public safety through innovative security solutions.
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={4} justifyContent="center">
                    {civilianItems.map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >

                                <Box
                                    sx={{
                                        position: 'relative',
                                        height: 260,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        // Glass Style (Lighter)
                                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                        backdropFilter: 'blur(16px)',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        borderRadius: 2,
                                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            border: '1px solid rgba(255, 255, 255, 0.5)',
                                            transform: 'translateY(-5px)',
                                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
                                        }
                                    }}
                                >
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Box
                                            component="img"
                                            src={item.image}
                                            alt={item.title}
                                            sx={{
                                                width: 100,
                                                height: 100,
                                                objectFit: 'contain',
                                                mb: 3,
                                                filter: 'brightness(0) invert(1)'
                                            }}
                                        />
                                        <Typography variant="h6" fontWeight="bold" sx={{ letterSpacing: 1, color: '#fff' }}>
                                            {item.title}
                                        </Typography>
                                    </Box>
                                </Box>

                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}

export default OfferingSectionComponent;
